// Helper function to convert category codes to display names
export const getCategoryDisplayName = (category) => {
    if (!category) return 'Document';

    const categoryMap = {
        'appointment': 'Appointment Letter',
        'payslip': 'Payslip',
        'termination': 'Termination Letter',
        'promotion': 'Promotion Letter',
        'experience': 'Experience Letter',
        'confirmation': 'Confirmation Letter',
        'increment': 'Increment Letter',
        'transfer': 'Transfer Letter',
        'resignation': 'Resignation Letter',
        'offer': 'Offer Letter',
        'warning': 'Warning Letter',
        'appreciation': 'Appreciation Letter',
        'relieving': 'Relieving Letter',
        'internship': 'Internship Letter',
        'contract': 'Contract Letter',
        'noc': 'No Objection Certificate',
        'bonafide': 'Bonafide Certificate',
        'salary': 'Salary Certificate',
        'company': 'Company Document'
    };

    return categoryMap[category.toLowerCase()] ||
           category.charAt(0).toUpperCase() + category.slice(1);
};
